__turbopack_context__.v({
  "className": "inter_14dde3db-module__cZuVgG__className",
  "variable": "inter_14dde3db-module__cZuVgG__variable",
});
